import React from "react";
import { greyClockIcon } from "../themes/images";
import moment from "moment-timezone";

class BookingPricingCard extends React.Component {
  render() {
    let type = this.props.selectedType;
    let item = this.props.item;
    let selectedLocation = this.props.selectedLocation;
    const offerDiscount = this.props.offerDiscount; // added

    type = type.toLowerCase().split(" / ")[0].trim();
    let includeText = "";
    let isSelected = false;
    let updateStyle = this.props.updateStyle ? this.props.updateStyle : false;

    if (this.props.bundleSelected !== null) {
      if (this.props.selectedService) {
        if (typeof this.props.selectedService == "object") {
          if (
            this.props.selectedService[0].id == this.props.item.service[0]._id
          ) {
            isSelected = true;
          }
        } else {
          if (this.props.selectedService == this.props.item.service[0]._id) {
            isSelected = true;
          }
        }
      }
    } else {
      if (this.props.selectedService == this.props.item._id) {
        isSelected = true;
      }
      if (item.isSelected) {
        isSelected = true;
      }
    }

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentHour = this.props.dateRange
      ? moment(this.props.dateRange.split(" - ")[0], "MMM Do h:mma").hour()
      : moment().hour();

    // Skip regular discount logic if offerDiscount is present (for resume booking)
    let salePrice = offerDiscount
      ? false
      : item.discount
      ? currentHour > item.discount.hour
        ? Number(item[type].value) - Number(item.discount.value)
        : false
      : false;

    switch (item["name"].toLowerCase().trim()) {
      case "express wash":
      case "hand polish":
      case "interior detail":
        includeText = "What's included";
        break;
      case "economy wash":
        includeText = "Express wash plus";
        break;
      case "premium wash":
        includeText = "Express wash plus +";
        break;
      case "super wash":
        includeText = "Premium wash plus +";
        break;
      case "mini detail":
        includeText = "Super wash plus +";
        break;
      case "full detail":
        includeText = "Hand Polish + Interior Detail +";
        if (selectedLocation.posId === 29) {
          includeText = "Interior Detail +";
        }
        break;
      case "paint protection":
      case "ceramic coating":
        includeText = "Full Detail plus +";
        break;
      default:
        includeText = "";
        break;
    }

    let price = 0;
    let active = true;

    if (item[type]) {
      price = item[type].value;
      active = item[type].active;
    } else {
      active = false;
    }

    if (price == 0) {
      active = false;
    }

    // Calculate discounted price based on offerDiscount
    let discountedPrice = null;
    if (offerDiscount) {
      if (offerDiscount.type === "percent") {
        discountedPrice = price * (1 - offerDiscount.value / 100);
      } else if (offerDiscount.type === "fixed") {
        discountedPrice = price - offerDiscount.value;
      }
    }

    // Final price - offerDiscount takes priority for resume booking
    let finalPrice = discountedPrice !== null ? discountedPrice : price;

    if (!active) {
      return null;
    } else {
      return (
        <div
          className={
            "pricingCard" +
            (item["popular"] ? " mostPopular" : "") +
            (isSelected ? " selectedService" : "") +
            (updateStyle ? " updatedLeftAlign" : "")
          }
        >
          {updateStyle ? (
            <div className="UpdatedHeading">
              <h2
                className={`pricingCardHeading ${
                  updateStyle ? " updatedPricingHeading" : ""
                }`}
              >
                {item.name}
              </h2>
              <h2 className={"pricingCardText"}>
                {finalPrice !== price ? (
                  <>
                    <span className="originalPrice">${price.toFixed(2)}</span> $
                    {finalPrice.toFixed(2)}
                  </>
                ) : (
                  <>${price.toFixed(2)}</>
                )}
              </h2>
              {offerDiscount && offerDiscount.type === "percent" && (
                <span className="offerBadge"> {offerDiscount.value}% OFF</span>
              )}
              <p className={`includedText lightBlueText`}>{includeText}</p>
            </div>
          ) : (
            <>
              <h2
                className={`pricingCardHeading ${
                  updateStyle ? " updatedPricingHeading" : ""
                }`}
              >
                {item.name}
              </h2>
              <h2 className={"pricingCardText"}>
                {finalPrice !== price ? (
                  <>
                    <span className="originalPrice">${price.toFixed(2)}</span> $
                    {finalPrice.toFixed(2)}
                  </>
                ) : (
                  <>${price.toFixed(2)}</>
                )}
              </h2>
              {offerDiscount && offerDiscount.type === "percent" && (
                <span className="offerBadge"> {offerDiscount.value}% OFF</span>
              )}
            </>
          )}

          {!updateStyle && (
            <>
              <div
                className={
                  isSelected
                    ? "bookNowButton"
                    : "blueBorderButton bookingPriceSelect"
                }
                onClick={() =>
                  this.props.selectServiceType(
                    item._id,
                    item.name,
                    item.pricing,
                    item.duration,
                    currentHour
                  )
                }
              >
                {isSelected ? "Selected" : "Choose"}
              </div>
              <div className="serviceDurationSection">
                <img className="durationIcon" src={greyClockIcon} alt="clock" />
                <p className="serviceDuration">
                  {" From " + item.duration + "min"}
                </p>
              </div>
            </>
          )}

          {!updateStyle && (
            <p className={`includedText lightBlueText`}>{includeText}</p>
          )}

          <ul className="includedItemsList">
            {item.includedOptions.map((listItem, i) => {
              if (
                listItem === "Vacuum" &&
                selectedLocation.name.includes("Tuggerah")
              ) {
                return <></>;
              }
              return (
                <li key={i} className="includedItem">
                  {listItem}
                </li>
              );
            })}
          </ul>

          {updateStyle && (
            <div className="bottomCardSection">
              <div className="serviceDurationSection">
                <img className="durationIcon" src={greyClockIcon} alt="clock" />
                <p className="serviceDuration">
                  {" From " + item.duration + "min"}
                </p>
              </div>
              <div
                className={
                  isSelected
                    ? "bookNowButton"
                    : "blueBorderButton bookingPriceSelect"
                }
                onClick={() =>
                  this.props.selectServiceType(
                    item._id,
                    item.name,
                    item.pricing,
                    item.duration,
                    currentHour
                  )
                }
              >
                {isSelected ? "Selected" : "Choose"}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}

export default BookingPricingCard;
